import React from 'react';
import ReactExport from 'react-export-excel';

import Form from 'react-bootstrap/Form';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import MaterialTable from 'material-table';
import { PatchedPagination } from '../services/PatchedPagination.js';
import { Container, Row, Button, Col, Spinner } from 'react-bootstrap';
import KeyboardBackspaceRoundedIcon from '@material-ui/icons/KeyboardBackspaceRounded';
import DateFnsUtils from '@date-io/date-fns';
import Grid from '@material-ui/core/Grid';
import DropdownButton from 'react-bootstrap/DropdownButton';
import Dropdown from 'react-bootstrap/Dropdown';
import Alert from 'react-bootstrap/Alert';
import RestServices from '../services/RestServices.js';
import { withAuthorization } from '../Session';

import {
    MuiPickersUtilsProvider,
    KeyboardDatePicker
} from '@material-ui/pickers';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const columns = [
    { title: 'Store Tag', field: 'StoreTag' },
    { title: 'Owner Name', field: 'username' },
    { title: 'Phone Number', field: 'WhatsAppNumber' },
    // {title:"UserType", field:"UserType"},
    { title: 'Assigned Date', field: 'date' },
    { title: 'Assigned By', field: 'UpdatedBy' }
];

export function MaterialUIPickers(props) {
    if (props.id == 'date-picker-inline1') {
        var date = new Date(),
            y = date.getFullYear(),
            m = date.getMonth();
        var firstDay = new Date(y, m, 1);
    } else {
        var firstDay = new Date();
    }
    const [selectedDate, setSelectedDate] = React.useState(firstDay);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        props.setDate(date);
    };

    return (
        <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
                disableToolbar
                variant="inline"
                format="yyyy-MM-dd"
                margin="normal"
                autoOk={true}
                id={props.id}
                label={props.label}
                value={selectedDate}
                onChange={handleDateChange}
                    autoOk={true}
                KeyboardButtonProps={{
                    'aria-label': 'change date'
                }}
            />
        </MuiPickersUtilsProvider>
    );
}

class Mapping extends React.Component {
    _isMounted = false;
    state = {
        showSpinner: false,
        alert: 0,
        alertMessage: '',
        flag: true,
        showTable: false,
        AllStoreTag: [],
        data: [],
        partialOwnership: [],
        customFromDate: this.getCustomFormattedDate('dateFrom'),
        customToDate: this.getCustomFormattedDate('dateTo')
    };

    getCustomFormattedDate(dateType) {
        if (dateType == 'dateFrom') {
            var date = new Date(),
                y = date.getFullYear(),
                m = date.getMonth();
            var firstDay = new Date(y, m, 1);
        } else {
            var firstDay = new Date();
        }

        var dd = String(firstDay.getDate()).padStart(2, '0');
        var mm = String(firstDay.getMonth() + 1).padStart(2, '0');
        var yyyy = firstDay.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    getFormattedDate(date) {
        var dd = String(date.getDate()).padStart(2, '0');
        var mm = String(date.getMonth() + 1).padStart(2, '0');
        var yyyy = date.getFullYear();

        date = yyyy + '-' + mm + '-' + dd;
        return date;
    }

    async componentDidMount() {
        this._isMounted = true;
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    async getAllStoreTag() {}

    StoreTagAddedinArray(querySnapshotData, StoreTag) {
        return querySnapshotData.some(function (el) {
            return el.StoreTag === StoreTag;
        });
    }

    SubmitFormData = async () => {
        if (this._isMounted) {
            this.setState({ showSpinner: true });
        }
        let mappingData = [];
        let data = {
            customFromDate: this.state.customFromDate,
            customToDate: this.state.customToDate
        };
        await RestServices.getStoreTagMapped(
            localStorage.getItem('FirebaseToken'),
            data
        )
            .then((response) => response.json())
            .then(async (responseData) => {
                
                let fullOwnershipArray = [];
                let partialOwnership = [];
                partialOwnership = responseData.partialOwnership;
                let MappedStoreTags = responseData.fullOwnership;
                //MappedStoreTags.sort((a, b) => (a.datetime < b.datetime) ? 1 : -1)

                if (partialOwnership.length > 0) {
                    MappedStoreTags.forEach(async (item) => {
                        if (
                            !this.StoreTagAddedinArray(
                                partialOwnership,
                                item.StoreTag
                            )
                        ) {
                            fullOwnershipArray.push(item);
                        } else {
                            partialOwnership.push(item);
                        }
                    });
                } else {
                    fullOwnershipArray = responseData.fullOwnership;
                }

                partialOwnership.sort((a, b) =>
                    a.datetime < b.datetime ? 1 : -1
                );

                if (this._isMounted) {
                    this.setState({
                        data: fullOwnershipArray,
                        partialOwnership: partialOwnership,
                        showSpinner: false,
                        flag: false,
                        alert: 0,
                        showTable: true
                    });
                }
            })
            .catch((err) => {});
    };

    render() {
        return (
            <Container>
                {this.state.showSpinner && <Spinner animation="border" />}
                <Row>
                    <h4 style={{ marginLeft: '1rem', marginRight: '1rem' }}>
                        Store Tags Mapped
                    </h4>
                </Row>
                <div>
                    <hr />
                </div>

                <Form.Row>
                    <MaterialUIPickers
                        id="date-picker-inline1"
                        label="Start Date"
                        setDate={(date) => {
                            if (this._isMounted) {
                                this.setState({
                                    customFromDate: this.getFormattedDate(date)
                                });
                            }
                        }}
                    />
                    <MaterialUIPickers
                        id="date-picker-inline2"
                        label="End Date"
                        setDate={(date) => {
                            if (this._isMounted) {
                                this.setState({
                                    customToDate: this.getFormattedDate(date)
                                });
                            }
                        }}
                    />
                    <Button
                        style={{ marginTop: '1.5rem' }}
                        variant="primary"
                        type="submit"
                        onClick={this.SubmitFormData}
                    >
                        Submit
                    </Button>
                </Form.Row>
                <Form.Row>
                    {this.state.showTable && (
                        <ExcelFile
                            element={
                                <button
                                    style={{ marginTop: '1.5rem' }}
                                    class="btn btn-primary"
                                >
                                    Download Data
                                </button>
                            }
                        >
                            <ExcelSheet
                                data={this.state.data}
                                name="Full Owners"
                            >
                                <ExcelColumn
                                    label="Store Tag"
                                    value="StoreTag"
                                />
                                <ExcelColumn
                                    label="Owner Name"
                                    value="username"
                                />
                                <ExcelColumn
                                    label="Phone Number"
                                    value="WhatsAppNumber"
                                />
                                <ExcelColumn
                                    label="Assigned Date"
                                    value="date"
                                />
                                <ExcelColumn
                                    label="Assigned By"
                                    value="UpdatedBy"
                                />
                            </ExcelSheet>
                            <ExcelSheet
                                data={this.state.partialOwnership}
                                name="Partial Owners"
                            >
                                <ExcelColumn
                                    label="Store Tag"
                                    value="StoreTag"
                                />
                                <ExcelColumn
                                    label="Owner Name"
                                    value="username"
                                />
                                <ExcelColumn
                                    label="Phone Number"
                                    value="WhatsAppNumber"
                                />
                                <ExcelColumn
                                    label="Assigned Date"
                                    value="date"
                                />
                                <ExcelColumn
                                    label="Assigned By"
                                    value="UpdatedBy"
                                />
                            </ExcelSheet>
                        </ExcelFile>
                    )}
                </Form.Row>

                {this.state.alert === 1 && (
                    <Alert variant="danger">{this.state.alertMessage}</Alert>
                )}

                {this.state.showTable && (
                    <MaterialTable
                        components={{
                            Pagination: PatchedPagination
                        }}
                        title="Full Owners"
                        columns={columns}
                        data={this.state.data}
                        options={{
                            filtering: true,
                            actionsColumnIndex: -1,
                            selection: false,
                            exportButton: true,
                            showFirstLastPageButtons: true,
                            pageSize: 15,
                            pageSizeOptions: [15, 25, 50, 100]
                        }}
                    />
                )}

                {this.state.showTable && (
                    <MaterialTable
                        components={{
                            Pagination: PatchedPagination
                        }}
                        title="Partial Owners"
                        columns={columns}
                        data={this.state.partialOwnership}
                        options={{
                            filtering: true,
                            actionsColumnIndex: -1,
                            selection: false,
                            exportButton: true,
                            showFirstLastPageButtons: true,
                            pageSize: 15,
                            pageSizeOptions: [
                                15,
                                25,
                                50,
                                100,
                                {
                                    value: this.state.partialOwnership.length,
                                    label: 'All'
                                }
                            ]
                        }}
                    />
                )}
            </Container>
        );
    }
}
const condition = (authUser) => !!authUser;
export default withAuthorization(condition)(Mapping);
